import { Role } from "../../types/role";

const KNIan: Role = {
  primary: ["Abschluss", "Antizipation", "Nervenstaerke", "OhneBall"],
  secondary: [
    "Ballannahme",
    "Kopfball",
    "Technik",
    "Entscheidungen",
    "Antritt",
  ],
  physis: "angriff",
};

export const KNI = {
  KNIan,
};
